import { render } from "./MeasureDetail.vue?vue&type=template&id=b17bf37a&scoped=true"
import script from "./MeasureDetail.vue?vue&type=script&lang=js"
export * from "./MeasureDetail.vue?vue&type=script&lang=js"

import "./MeasureDetail.vue?vue&type=style&index=0&id=b17bf37a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b17bf37a"]])

export default __exports__